import { useContext } from 'react';

import { TimeseriesLegendContext } from '../context/TimeseriesLegend.context.js';

export const useTimeseriesLegend = () => useContext(TimeseriesLegendContext);
